// extracted by mini-css-extract-plugin
export default {"downloadPracto":"DownloadPracto_downloadPracto__Sz6vk"};